// extracted by mini-css-extract-plugin
export var component = "Section-module--component--tjfB1";
export var wrapper = "Section-module--wrapper--jftek";